import {
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsFlipHorizontally,
  dataLabelsHideThreshold,
  dataLabelsSizes,
  dimension,
  dimensionSelector,
  inverse,
  legendPosition,
  palette,
  showDataLabels,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.COMPARISON, FAMILY.DECOMPOSITION],
  title: "Stacked Column Chart",
  defaultHeight: 6,
  controls: [{ ...dimension, metricName: "decompositionMetricSecondary" }, inverse],
  settings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    xAxisName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 1",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    xAxisSecondaryName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 2",
      gridPosition: [1, 1],
      forAxis: "decompositionMetricSecondary",
    },
    yAxisName: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "campaign_kpi",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricSecondary: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
  },
  planSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [6, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [6, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [7, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [7, 1] },
    dataLabelsHideThreshold: { ...dataLabelsHideThreshold, gridPosition: [8, 1] },
    dataLabelsFlipHorizontally: { ...dataLabelsFlipHorizontally, gridPosition: [8, 0] },
    xAxisName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 1",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    xAxisSecondaryName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 2",
      gridPosition: [1, 1],
      forAxis: "decompositionMetricSecondary",
    },
    yAxisName: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "campaign_kpi",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricSecondary: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [9, 0] },
  },
  planExploreSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [6, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [6, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [7, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [7, 1] },
    dataLabelsHideThreshold: { ...dataLabelsHideThreshold, gridPosition: [8, 1] },
    dataLabelsFlipHorizontally: { ...dataLabelsFlipHorizontally, gridPosition: [8, 0] },
    xAxisName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 1",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    xAxisSecondaryName: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title 2",
      gridPosition: [1, 1],
      forAxis: "decompositionMetricSecondary",
    },
    yAxisName: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "campaign_kpi",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricSecondary: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [9, 0] },
  },
};
